import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { DialogDescription } from "@/components/ui/dialog";
import { RELATIONSHIP_TYPES } from "@/constants/archimate";

export function CreateRelationshipDialog({ open, onOpenChange, sourceElement, targetElement, onCreate }) {
  const [type, setType] = useState("association");
  const [name, setName] = useState("");

  useEffect(() => {
    if (open) {
      setType("association");
      setName("");
    }
  }, [open]);

  if (!sourceElement || !targetElement) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="create-relationship-dialog">
        <DialogHeader>
          <DialogTitle>New Relationship</DialogTitle>
          <DialogDescription>Pick the ArchiMate relationship type connecting these two elements.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="flex items-center gap-2 text-sm">
            <span className="font-medium truncate">{sourceElement.name}</span>
            <span className="text-muted-foreground">&rarr;</span>
            <span className="font-medium truncate">{targetElement.name}</span>
          </div>
          <div>
            <label className="text-xs font-medium text-muted-foreground">Relationship Type</label>
            <Select value={type} onValueChange={setType}>
              <SelectTrigger data-testid="create-relationship-type-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {Object.entries(RELATIONSHIP_TYPES).map(([key, v]) => (
                  <SelectItem key={key} value={key}>
                    {v.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <label className="text-xs font-medium text-muted-foreground">Label (optional)</label>
            <Input data-testid="create-relationship-name-input" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="create-relationship-cancel-button">
            Cancel
          </Button>
          <Button
            onClick={() => {
              onCreate({ type, name });
              onOpenChange(false);
            }}
            data-testid="create-relationship-submit-button"
          >
            Create
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
